import { Box, Typography } from "@mui/material";
import { Fragment } from "react";

export type WorkspaceMetaRow = {
  title: string;
  value: string;
  /** Theme colour token for the value, e.g. "warning.main". */
  color?: string;
};

/**
 * Phone layout for a workspace meta strip: label/value rows instead of boxed
 * pills, so a long value (a client name, a job name) gets the full panel width
 * and the block stays short.
 */
export default function WorkspaceMetaList({
  rows,
}: {
  rows: WorkspaceMetaRow[];
}) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "auto minmax(0, 1fr)",
        columnGap: 1.25,
        rowGap: 0.25,
        mt: 0.75,
        px: 1.25,
        py: 0.85,
        borderRadius: 2,
        bgcolor: (theme) =>
          theme.palette.mode === "dark" ? "grey.900" : "grey.50",
        border: 1,
        borderColor: "divider",
      }}
    >
      {rows.map((row) => (
        <Fragment key={row.title}>
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ lineHeight: 1.7, letterSpacing: 0.06, fontWeight: 600 }}
          >
            {row.title}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={700}
            sx={{
              lineHeight: 1.7,
              minWidth: 0,
              overflowWrap: "anywhere",
              color: row.color ?? "text.primary",
            }}
          >
            {row.value}
          </Typography>
        </Fragment>
      ))}
    </Box>
  );
}
